document.addEventListener("DOMContentLoaded", function () {

const sizeGuideModal = document.querySelector('[data-size-guide-modal]');
const sizeGuideModalContent = sizeGuideModal?.querySelector('[data-size-guide-content]');
const sizeGuideOpenerBtn = document.querySelector('[data-size-guide]');
const sizeGuideCloseBtn = sizeGuideModal?.querySelector('[data-size-guide-close]');

sizeGuideModal.scrollTop = 0;

if (sizeGuideOpenerBtn) {
  sizeGuideOpenerBtn?.addEventListener("click", e => {
    e.preventDefault();
    sizeGuideOpener();
  });
}

if(sizeGuideCloseBtn) {
  sizeGuideCloseBtn.addEventListener("click", e => {
    e.preventDefault();
    sizeGuideClose();
  });
}

sizeGuideModal?.addEventListener("click", e => {
  sizeGuideClose();
});

sizeGuideModalContent?.addEventListener("click", e => {
  e.stopPropagation();
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') { 
    const isNotCombinedKey = !(e.ctrlKey || e.altKey || e.shiftKey);
    if (isNotCombinedKey) { 
      sizeGuideClose();
    }
  }
});

function sizeGuideClose() {
  if(sizeGuideModal) {
    sizeGuideModal.classList.remove("is-visible");
    document.body.style.overflowY = "auto";
    sizeGuideModal.scrollTop = 0;
  }
}

function sizeGuideOpener() {
  if(sizeGuideModal) {
    sizeGuideModal.classList.add("is-visible");
    sizeGuideModal.scrollTop = 0;
    document.body.style.overflowY = "hidden";
    sizeGuideAnimations();
  } 
}

function sizeGuideAnimations() {
  const sizeGuideModalContent = sizeGuideModal?.querySelector('[data-size-guide-content]');
    if (sizeGuideModalContent) {
      sizeGuideModalContent.style.transitionDelay = `100ms`;
    }
}

// Progress bar (visible only on mobile version)

var sizeGuideHolder = document.querySelector(".sizeGuide-holder");
var progressBar = document.getElementById("size-guide--progress-bar-inner");

sizeGuideHolder?.addEventListener("scroll", updateProgressBar);

function updateProgressBar() {
    var scrollableWidth = sizeGuideHolder.scrollWidth - sizeGuideHolder.clientWidth;
    var scrolled = (sizeGuideHolder.scrollLeft / scrollableWidth) * 100;
    progressBar.style.width = scrolled + "%";
}

// Set the current country as first table column

  const sizeGuideTable = document.querySelector("table.sizeGuide");
  const localization = Shopify.country
  const mobileView = window.matchMedia("(max-width: 768px)").matches;


  function rearrangeTableColumns(localization) {
    const thElements = Array.from(sizeGuideTable.querySelectorAll("th")).filter(
      (th) => th.getAttribute("data-localization") === localization
    );

    const tdElements = Array.from(sizeGuideTable.querySelectorAll(`td[data-localization="${localization}"]`));

    const headerRow = sizeGuideTable.querySelector("thead tr");
    thElements.forEach((th) => headerRow.prepend(th));

    const rows = Array.from(sizeGuideTable.querySelectorAll("tbody tr"));
    rows.forEach((row) => {
      tdElements.forEach((td) => {
        if (td.parentElement === row) {
          td.remove();
          row.prepend(td);
        }
      });
    });
  }

 if(sizeGuideTable && mobileView && localization) {
    rearrangeTableColumns(localization);
 } 

});